import React from 'react';

const MyDogs = ({ dogs, onRefresh }) => {
  return (
    <div className="dogs-panel">
      <h2>My Dogs</h2>
      {dogs.length === 0 ? (
        <p>No dogs yet. Create one to get started!</p>
      ) : (
        <div className="dogs-list">
          {dogs.map((dog) => (
            <div key={dog.id} className="dog-card">
              <h3>{dog.name}</h3>
              <p><strong>Breed:</strong> {dog.breed}</p>
              <p><strong>Age:</strong> {dog.age_years} years {dog.age_months} months</p>
              <p><strong>Size:</strong> {dog.size}</p>
              <p><strong>Weight:</strong> {dog.weight_kg} kg</p>
              {dog.temperament && <p><strong>Temperament:</strong> {dog.temperament}</p>}
              {dog.walking_behaviour && <p><strong>Walking Behaviour:</strong> {dog.walking_behaviour}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyDogs;
